import { render, staticRenderFns } from "./GoodsCategoryDetail.vue?vue&type=template&id=5b2136bc&"
import script from "./GoodsCategoryDetail.vue?vue&type=script&lang=js&"
export * from "./GoodsCategoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports